import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/subscriptions/RequestsTable';
import { Stats } from '@/components/reports/subscriptions/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetSubscriptionFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function SubscriptionReports() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSubscriptionFilters());
      dispatch(setSearch({ key: 'subscriptionReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.subscription.title', 'Subscription Reports')}
      desc={t(
        'reports.subscription.pageDesc',
        'A detailed overview of all subscription activity on the platform'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
